
import React from 'react';
import { ArcaRedirect } from '../../code/ArcaRedirect';
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { UserLinksPanel } from '../controls/Navigation/UserLinksPanel';
import { LoginPanel } from '../controls/Security/LoginPanel';
import { ArcaComponent } from './ArcaComponent';

export class Login extends ArcaComponent {

    constructor(props) {
        super(props);
        this.state = {
            email: null,
            password: null,
            formValid: false,
            passwordValid: false,
            emailValid: false,
            statusText: null,
            isError: false,
            checked: false
        };
    }

    logoff() {
        ArcaSecurity.Logoff();

        this.setState({
            email: null,
            password: null,
            formValid: false,
            passwordValid: false,
            emailValid: false,
            statusText: null,
            isError: false
        });
    }

    /*eslint-disable */
    render() {
        return (
            <div>
                <LoginPanel onLogon={this.onLogin.bind(this)} />
            </div >
        );
    }

    onCheck() {
        var checked = !this.state.checked;
        this.setState({
            checked: checked,
            formValid: this.state.emailValid && this.state.passwordValid && checked
        });
    }

    /*eslint-enable */


    async onLogin() {
        ArcaRedirect.Push('/Home');
    }
}
